import { Button } from '@tmov/design-system';
import { WaveVariantD } from '@tmov/design-system/icons';
import { Tokens } from '@tmov/design-system/theme/types';
import { notification } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { useBoolean } from '../../../../../../../../../hooks/useBoolean';
import apiNetCore from '../../../../../../../../../services/apiNetCore';
import { IconContainer, LoadingContainer } from './styles';

export function BaixarTodosButton({ idLoteConjunto }) {
  const { value: isLoading, setTrue, setFalse } = useBoolean();
  const buttonStyle = { width: '100%', marginTop: '24px' };

  const baixarTodosDocumentosPorIdLoteConjunto = async () => {
    setTrue();

    try {
      const response = await apiNetCore.get(
        `LoteConjunto/${idLoteConjunto}/documentos/baixar-todos`,
        { responseType: 'blob' }
      );

      if (response.status === 200) {
        const file = new Blob([response.data], {
          type: response.data.type ?? 'application/pdf',
        });
        const fileURL = URL.createObjectURL(file);
        const newWindow = window.open(fileURL);
        if (newWindow) newWindow.focus();
      }
    } catch (error) {
      notification.error({
        message: 'Erro ao baixar documentos',
        description:
          'Ocorreu um erro ao baixar os documentos, tente novamente mais tarde',
        className: 'custom-class',
        style: {
          width: 568,
          background: Tokens.eixods.colors.support.vanderleia['5'],
          borderLeftStyle: 'solid',
          borderLeftWidth: '4px',
          borderLeftColor: Tokens.eixods.colors.feedback.error,
        },
      });
    } finally {
      setFalse();
    }
  };

  const hadleClick = () => {
    baixarTodosDocumentosPorIdLoteConjunto();
  };

  const Loading = () => (
    <LoadingContainer>
      <div>Processando</div>
      <IconContainer>
        <WaveVariantD size="16px" />
      </IconContainer>
    </LoadingContainer>
  );

  return (
    <Button
      data-testid="baixar-todos-button"
      style={buttonStyle}
      onClick={hadleClick}
      disabled={isLoading}
    >
      {isLoading ? Loading() : 'Baixar todos'}
    </Button>
  );
}

BaixarTodosButton.propTypes = {
  idLoteConjunto: PropTypes.number.isRequired,
};
